import { apiService } from './apiService';

export const gateCheckpointService = {
  async getFormOptions() {
    return await apiService.get('/gate-checkpoints/form-options');
  },

  async getAll(params?: { warehouseId?: string; status?: 'open' | 'closed' | 'all'; startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.warehouseId) queryParams.append('warehouseId', params.warehouseId);
    if (params?.status && params.status !== 'all') queryParams.append('status', params.status);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    const query = queryParams.toString();
    return await apiService.get(`/gate-checkpoints${query ? `?${query}` : ''}`);
  },

  async create(data: any) {
    return await apiService.post('/gate-checkpoints', data);
  },

  async exit(id: string | number, data?: { exitAt?: string }) {
    return await apiService.put(`/gate-checkpoints/${id}/exit`, data || {});
  },
};
